import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/expense-categories')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/expense-categories-page')),
  staticData: { titleKey: 'expenseCategories' },
});
